export default __webpack_public_path__ + "static/media/Spinner-1s-98px.2a0623e8.gif";